import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface SimulateNavigationProps {
  currentGroupIndex: number;
  totalGroups: number;
  canGoPrevious: boolean;
  canGoNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  isLast: boolean;
}

export function SimulateNavigation({
  currentGroupIndex,
  totalGroups,
  canGoPrevious,
  canGoNext,
  onPrevious,
  onNext,
  isLast,
}: SimulateNavigationProps) {
  return (
    <div className="flex justify-between items-center pt-6 border-t bg-white rounded-lg p-4">
      <Button variant="outline" onClick={onPrevious} disabled={!canGoPrevious} size="sm">
        <ChevronLeft className="h-4 w-4 mr-1" /> Previous
      </Button>
      <div className="text-sm text-gray-600">
        Section {currentGroupIndex + 1} of {totalGroups}
      </div>
      <Button onClick={onNext} disabled={!canGoNext} size="sm">
        {isLast ? 'Finish' : 'Next'} <ChevronRight className="h-4 w-4 ml-1" />
      </Button>
    </div>
  );
}
